import React, { FC } from 'react';
import { DomainRoot } from '../features/domain';

export const Domain: FC = () => {
  return <DomainRoot />;
};
